export default "__VITE_ASSET__2bddfe9a__"